import { render, staticRenderFns } from "./DuelsGameHeader.vue?vue&type=template&id=4496dd7a&scoped=true"
import script from "./DuelsGameHeader.vue?vue&type=script&lang=js"
export * from "./DuelsGameHeader.vue?vue&type=script&lang=js"
import style0 from "./DuelsGameHeader.vue?vue&type=style&index=0&id=4496dd7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4496dd7a",
  null
  
)

export default component.exports